import { useEffect, useState } from "react";
import api from "./api";

// Module-level cache so the value is fetched once per session.
// Backend default lives in MAX_KEYWORDS_PER_CLIENT (.env). 150 is the fallback
// so the UI stays usable even if /api/config 500s.
const DEFAULT_CONFIG = { max_keywords_per_client: 150 };
let cached = null;
let inflight = null;

async function loadConfig() {
  if (cached) return cached;
  if (inflight) return inflight;
  inflight = api
    .get("/config")
    .then(({ data }) => {
      cached = { ...DEFAULT_CONFIG, ...(data || {}) };
      return cached;
    })
    .catch(() => {
      cached = { ...DEFAULT_CONFIG };
      return cached;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

export function useAppConfig() {
  const [config, setConfig] = useState(cached || DEFAULT_CONFIG);
  useEffect(() => {
    let alive = true;
    loadConfig().then((c) => {
      if (alive) setConfig(c);
    });
    return () => {
      alive = false;
    };
  }, []);
  return config;
}
